module.exports = __webpack_public_path__ + "static/media/ms-symbollockup_signin_light.ad23a60a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ms-symbollockup_signin_light.svg
// module id = 858
// module chunks = 0